import React from 'react';
import { TextField, TextFieldProps, Badge, Tooltip } from '@mui/material';
import { Warning as WarningIcon } from '@mui/icons-material';

type TextInputProps = TextFieldProps & {
    warning?: boolean;
};

const TextInput = React.memo(React.forwardRef<HTMLDivElement, TextInputProps>(({
  sx,
  size,
  warning = false,
  value,
  ...props
}, ref) => {
  // Show warning if warning prop is true AND value is empty/undefined/null
  const showWarning = warning && (!value || value.toString().trim() === '');

  return (
    <Badge
      badgeContent={
        showWarning ? (
          <Tooltip title="We recommend filling this field, it will help us to find better matches for your truck.">
            <WarningIcon
              sx={{
                fontSize: 16,
                color: 'warning.main'
              }}
            />
          </Tooltip>
        ) : null
      }
      sx={{
        width: '100%',
      }}
    >
      <TextField
        {...props}
        ref={ref}
        variant="outlined"
        size={size}
        value={value}
        InputProps={props.InputProps}
        sx={{ ...sx, width: '100%' }}
      />
    </Badge>
  );
}));

TextInput.displayName = 'TextInput';

export default TextInput;
